module.exports = __webpack_public_path__ + "static/extensions2-11deb20e0831a606e94a8da639d4d273.png";